import React from "react";
import "./GameDesignProcessStyle.scss";
import { slotGameDesignProcessTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const GameDesignProcessSection = () => {
  return (
    <section className="game-design-process-section">
      <div className="game-design-process-wrap">
        <SectionHeading>
          {slotGameDesignProcessTextContent.headingText}
        </SectionHeading>

        <div className="game-design-process-box">
          {slotGameDesignProcessTextContent.content.map((item, index) => (
            <div className="game-design-process-container" key={index}>
              <div className="game-design-process-container-inner">
                <div className="text-box">
                  <h6 className="title-text">{item.titleText}</h6>
                  <p className="para-text">{item.paraText}</p>
                </div>

                <div className="img-box">
                  <img src={item.imageSrc} alt="Image" />
                </div>
              </div>

              <div className="divider-line">
                <img src="/assets/svg-img/divider-triangle.svg" alt="Image" className="triangle left-triangle" />
                <hr />
                <img src="/assets/svg-img/divider-triangle.svg" alt="Image" className="triangle right-triangle" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GameDesignProcessSection;
